import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import BaggageSelling from "./BaggageSelling";
import BaggageReturn from "./BaggageReturn";
import BookingBuyout from './BookingBuyout';
import TicketReturn from './TicketReturn';
import RestoreTicket from './RestoreTicket';
import {ModelListSelect} from 'vue-search-select';

export default {
    name: "cashier_dashboard_one",
    components: {
        Datepicker,
        BookingBuyout,
        BaggageSelling,
        BaggageReturn,
        TicketReturn,
        RestoreTicket,
        ModelListSelect,
    },
    data() {
        return {
            trips: [],
            ticketsTab: false,
            baggageSellingTab: false,
            baggageReturnTab: false,
            bookTicketTab: false,
            returnTicketTab: false,
            restoreTicketTab: false,
            trip_date: this.$moment().format("MM.DD.YYYY"),
            station_from: null,
            station_to: null,
            filter_status: null,
            headerHidden: false,
            stations: [],
            loading_states: {
                list: false,
            },
            current_user: {
                user_role: '',
                username: '',
            },
            sold: '',

            //alx e-pos
            epos: {
                enabled: false,
                url: 'http://localhost:8347/uzpos',
                token: 'DXJFX32CN1296678504F2',
                printer_size: 80,
                device_id: null,
                zreport_button_disabled: false,
                //zreport_button_disabled: true,
                //z_report_opened: false,
            },
        };
    },

    mounted() {

    },

    methods: {
        //alx e-pos
        /*
        check_epos_z_report() {
            //alx e-pos z report
            this.$http.post(this.epos.url, {
                "token": this.epos.token,
                "method": "getZreportInfo",
                "printerSize": this.epos.printer_size, //80
                "zReportId": 0
                }).then(res2 => {
                    if (res2.data.error) {
                        if (res2.data.message) {
                            //alx E-POS FIXME: What the correct way to check the Z report status?
                            if (res2.data.message === "Отчет Z еще не открыт!") {
                                this.epos.z_report_opened = false;
                                this.epos.zreport_button_disabled = false;
                                return;
                            }
                            //console.log(res2);
                            this.errorMsg("E-POS: " + res2.data.message)
                        }
                        return;
                    }
                    this.epos.z_report_opened = true;
                    this.epos.zreport_button_disabled = false;

                    //console.log(res2);

                }).catch((err) => {
                    this.errorMsg("E-POS: Невозможно получить данные!")
                }).finally(() => {
                    // FIXME: ...

                })
        },
        open_epos_z_report() {
            this.epos.zreport_button_disabled = true;
            //alx e-pos open/close z report
            let method = "openZreport";
            if(this.epos.z_report_opened) {
                method = "closeZreport";
            }

            this.$http.post(this.epos.url, {
                    "token": this.epos.token,
                    "method": method
                }).then(res2 => {
                    if (res2.data.error) {
                        if (res2.data.message) {
                            this.errorMsg("E-POS: " + res2.data.message)
                        }
                        return;
                    }

                    //console.log(res2);
                    if(this.epos.z_report_opened) {
                        this.epos.z_report_opened = false;
                    } else {
                        this.epos.z_report_opened = true;
                    }
                    return true;

                }).catch((err) => {
                    this.errorMsg("E-POS: Невозможно получить данные!")
                }).finally(() => {
                    // FIXME: ...
                    this.epos.zreport_button_disabled = false;

                })
        },
        */
        cashier_menu_arcus(){
            axios.post('http://localhost:5000/Payment/MenuCashier')
                .catch(error => {
                    this.$swal(
                        error.response.data.message || 'Произошла непредвиденная ошибка.',
                        error.response.data.details || '',
                        'error');
                });
        },
        cashier_last_result_arcus(){
            axios.get('http://localhost:5000/Payment/ReadFile')
                .catch(error => {
                    this.$swal(
                        error.response.data.message || 'Произошла непредвиденная ошибка.',
                        error.response.data.details || '',
                        'error');
                });
        },
        get_epos_data() {
            let epos_data = {};
            this.$api.get('epos.data').then(res => {
                epos_data = res.data;
                //console.log(epos_data);
                if (epos_data.enabled) {
                    this.$http.post(epos_data.url, {
                        "token": epos_data.token,
                        "method": "getDeviceId",
                    }).then(res2 => {
                        if (res2.data.error) {
                            if (res2.data.message) {
                                this.errorMsg("E-POS: " + res2.data.message)
                            }
                            return;
                        }
                        console.log("E-POS DeviceId: ", res2.data.message);

                        this.epos.enabled = true;
                        this.epos.device_id = res2.data.message;
                        this.epos.url = epos_data.url;
                        this.epos.token = epos_data.token;
                        this.epos.printer_size = epos_data.printer_size;

                        //this.check_epos_z_report();

                    }).catch((err) => {
                        this.errorMsg("E-POS: Невозможно получить данные! \n" + err);
                    }).finally(() => {

                    });
                }
            });
        },
        close_epos_z_report() {
            if (confirm('Вы точно хотите закрыть кассу?')) {
                this.epos.zreport_button_disabled = true;
                //alx e-pos close z report

                let method = "closeZreport";
                this.$http.post(this.epos.url, {
                    "token": this.epos.token,
                    "method": method
                }).then(res2 => {
                    if (res2.data.error) {
                        if (res2.data.message) {
                            this.errorMsg("E-POS: " + res2.data.message)
                        }
                    } else {
                        this.successMsg("E-POS: Кассовая смена успешно закрыта!");
                    }

                }).catch((err) => {
                    this.errorMsg("E-POS: Невозможно получить данные!\n" + err);
                    this.epos.zreport_button_disabled = false;
                }).finally(() => {
                    this.epos.zreport_button_disabled = false;
                })
            } else {
                return;
            }
        },
        errorMsg(message) {
            if (_.isArray(message)) {
                message.forEach(error => {
                    Vue.notify({
                        type: 'error',
                        group: 'foo',
                        title: '',
                        text: error.message,
                        duration: -1,
                    });
                })
            } else {
                Vue.notify({
                    type: 'error',
                    group: 'foo',
                    title: '',
                    text: message,
                    duration: -1,
                });
            }
        },
        successMsg(message) {
            if (_.isArray(message)) {
                message.forEach(error => {
                    Vue.notify({
                        type: 'success',
                        group: 'foo',
                        title: '',
                        text: error.message
                    });
                })
            } else {
                Vue.notify({
                    type: 'success',
                    group: 'foo',
                    title: '',
                    text: message
                });
            }
        },

        selectPlace(trip) {
            //alx e-pos
            /*
            if (this.epos.enabled && this.epos.device_id !== null && !this.epos.z_report_opened) {
                this.errorMsg("E-POS: Необходимо открыть кассовую смену!");
                return false;
            }
            */

            let from = this.station_from ? this.station_from : trip.from_id;
            let to = this.station_to ? this.station_to : trip.to_id;
            this.$router.push('/cashier/dashboard-two/' + trip.trip_id + '/' + from + '/' + to);
        },
        async loadTrips() {
            this.loading_states.list = true;
            let postData = {};
            postData.date = this.formattedDate;
            if (this.station_from !== null) {
                postData.from = this.station_from;
            }
            if (this.station_to !== null) {
                postData.to = this.station_to;
            }
            if (this.filter_status !== null && this.filter_status !== -1) {
                postData.status = this.filter_status;
            }
            await this.$api.post('cashier.dashboard-one', postData).then(({data}) => {
                this.trips = data.data;
                this.current_user = data.user;
            }).finally(() => {
                this.loading_states.list = false;
            });
        },
        loadStations() {
            let searchData = {};
            this.$api.get('trips.stations', searchData).then(({data}) => {
                this.stations = data;
            });
        },
        changeHeader(activeTab) {
            switch (activeTab) {
                case 'ticketsTab':
                    this.headerHidden = false;
                    break;
                case 'baggageSellingTab':
                    this.headerHidden = true;
                    break;
                case 'baggageReturnTab':
                    this.headerHidden = true;
                    break;
                case 'bookTicketTab':
                    this.headerHidden = true;
                    break;
                case 'returnTicketTab':
                    this.headerHidden = true;
                    break;
                case 'restoreTicketTab':
                    this.headerHidden = true;
                    break;
            }
        }
    },
    computed: {
        formattedDate: function () {
            let date = new Date(this.trip_date);
            return date.getFullYear() + '-' +
                (date.getMonth() + 1) + '-' +
                date.getDate();
        },
    },
    watch: {
        trip_date: function () {
            this.loadTrips();
        },
        station_from: function (n, o) {
            n !== o && this.loadTrips();
            if (this.station_from !== null) {
                localStorage.station_from_choosen = this.station_from;
            } else {
                delete localStorage.station_from_choosen;
            }
        },
        station_to: function (n, o) {
            n !== o && this.loadTrips();
        },
        filter_status: function (n, o) {
            n !== o && this.loadTrips();
        }
    },
    created() {
        if (typeof localStorage.station_from_choosen !== 'undefined') {
            this.station_from = parseInt(localStorage.station_from_choosen);
        }
        this.loadTrips();
        this.trip_date = this.$moment().format("YYYY-MM-DD");
        this.$store.state.cashier.basket = [];
        let active_tab = this.$route.params['tab'];
        switch (active_tab) {
            case 'ticketsTab':
                this.baggageSellingTab = false;
                this.baggageReturnTab = false;
                this.ticketsTab = true;
                this.bookTicketTab = false;
                this.returnTicketTab = false;
                this.headerHidden = false;
                break;

            case 'baggageSellingTab':
                this.baggageSellingTab = true;
                this.baggageReturnTab = false;
                this.bookTicketTab = false;
                this.ticketsTab = false;
                this.returnTicketTab = false;
                this.headerHidden = true;
                break;

            case 'baggageReturnTab':
                this.baggageSellingTab = false;
                this.baggageReturnTab = true;
                this.bookTicketTab = false;
                this.ticketsTab = false;
                this.returnTicketTab = false;
                this.headerHidden = true;
                break;

            case 'bookTicketTab':
                this.baggageSellingTab = false;
                this.baggageReturnTab = false;
                this.bookTicketTab = true;
                this.ticketsTab = false;
                this.returnTicketTab = false;
                this.headerHidden = true;
                break;

            case 'returnTicketTab':
                this.baggageSellingTab = false;
                this.baggageReturnTab = false;
                this.returnTicketTab = true;
                this.ticketsTab = false;
                this.bookTicketTab = false;
                this.headerHidden = true;
                break;

            case 'restoreTicketTab':
                this.baggageSellingTab = false;
                this.baggageReturnTab = false;
                this.restoreTicketTab = true;
                this.returnTicketTab = false;
                this.ticketsTab = false;
                this.bookTicketTab = false;
                this.headerHidden = true;
                break;
        }
        this.loadStations();

        this.$api.get('cashier.sold').then(data => {
            this.sold = data.data;
        }).finally(() => {
            this.loading_states.list = false;
        });
        //alx e-pos
        this.get_epos_data();
    },

}
